import type React from 'react';
import SvgMaskIcon from '../SvgMaskIcon';

interface PanelRightIconProps {
    width?: number;
    height?: number;
    color?: string;
}

const INNER =
    '<g fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M3 5v14"/><path d="M21 12H7"/><path d="m15 18 6-6-6-6"/></g>';

const PanelRightIcon: React.FC<PanelRightIconProps> = ({
    width = 20,
    height = 20,
    color = '#656565',
}) => <SvgMaskIcon viewBox="0 0 24 24" inner={INNER} width={width} height={height} color={color} />;

export default PanelRightIcon;
